import React from 'react'
import Link from 'next/link'
import styles from './styles.module.scss'

const TextLink = (props: any) => <Link className={styles.link} {...props} />

export default TextLink
